export default __webpack_public_path__ + "static/media/temple_pic.704c41b2.jpg";